module.exports = __webpack_public_path__ + "img/blue_068.33fd5407.png";